<!--
  优惠券
  lovi 2020-07-01
-->
<template>
  <div class="w100">
    <van-nav-bar
      :title="$t('coupon.myDiscountCoupon')"
      :fixed="true"
      left-arrow
      @click-left="_back"
    />
    <van-tabs
      v-model="tabIndex"
      @click="changeTab(tabIndex)"
      animated
      swipeable
    >
      <van-tab v-for="(title, index) in tabTitle" :key="index">
        <template slot="title">
          <span
            class="default"
            :class="{ active: couponTypeFlag && index == 0 }"
          >
            {{ title }}
          </span>
        </template>
      </van-tab>
    </van-tabs>
    <div
      class="scroll-wrapper"
      :class="{
        noCrad: !listData.length && getListFlag
      }"
    >
      <div v-if="!listData.length && getListFlag" class="noCard-wrap">
        <img src="@/assets/images/public/pic_kong@2x.png" />
        <p class="text-gray">{{ $t("common.noData") }}</p>
      </div>
      <scroll
        v-if="listData.length && getListFlag"
        ref="scroll"
        :data="listData"
        :pullUpLoad="true"
        :pullDownRefresh="true"
        @pullingDown="pullingDown"
        @pullingUp="pullingUp"
      >
        <div class="coupon">
          <div
            class="item"
            :class="{ disabled: status }"
            v-for="(item, index) in listData"
            :key="index"
            @click="toDetail(item.id)"
          >
            <div class="info">
              <div class="left">
                <img :src="httpUrl + item.icon" />
              </div>
              <div class="center">
                <h3>{{ item.coupon_name }}</h3>
                <span
                  class="ticket"
                  :class="item.coupon_type == 2 ? 'style2' : 'style1'"
                >
                  {{
                    item.coupon_type == 2
                      ? $t("coupon.voucher")
                      : $t("coupon.cashback")
                  }}
                </span>
                <p>
                  {{ item.end_time }}
                  <span class="text-red" v-if="item.due">
                    {{ $t("coupon.AboutToExpired") }}
                  </span>
                </p>
              </div>
              <div class="right">
                <h4 :class="item.coupon_type == 2 ? 'text-orange' : 'text-red'">
                  {{ item.coupon_discount_amount }}P
                </h4>
                <p>
                  {{
                    item.coupon_type == 2
                      ? $t("coupon.unlimited")
                      : $t("coupon.upTo") +
                        item.coupon_amount +
                        "P" +
                        $t("coupon.available")
                  }}
                </p>
              </div>
            </div>
            <div class="use-info">
              <p class="text-gray text-hidden">{{ item.explanation }}</p>
              <van-button
                :type="item.coupon_type == 2 ? 'warning' : 'danger'"
                size="mini"
                :disabled="status ? true : false"
                @click.stop="clickButton"
              >
                {{
                  status == 0
                    ? $t("coupon.useImmediately")
                    : status == 1
                    ? $t("coupon.used")
                    : $t("coupon.expired")
                }}
              </van-button>
            </div>
            <div class="cro-wrap left">
              <div class="cro top"></div>
              <div class="cro bottom"></div>
            </div>
            <div class="cro-wrap right">
              <div class="cro top"></div>
              <div class="cro bottom"></div>
            </div>
          </div>
        </div>
      </scroll>
    </div>

    <!-- <van-overlay
      class-name="couponType-overlay"
      :show="couponTypeFlag"
      @click="couponTypeFlag = false"
    /> -->
    <div class="pull-down" v-if="couponTypeFlag">
      <p
        :class="{ active: couponType == item.key }"
        v-for="(item, index) in couponTypeList"
        :key="index"
        @click="clickCouponType(item.key)"
      >
        {{ item.name }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "coupon",
  meta: {
    service: false // 客服
  },
  components: {},
  data() {
    return {
      curIndex: 0,
      tabIndex: 0,
      tabTitle: [
        this.$t("coupon.unused"),
        this.$t("coupon.used"),
        this.$t("coupon.expired")
      ],
      couponTypeFlag: false,
      status: 0,
      couponType: 0,
      couponTypeList: [
        { key: 0, name: this.$t("common.all") },
        { key: 1, name: this.$t("coupon.platformCoupon") },
        { key: 2, name: this.$t("coupon.merchantCoupon") }
      ],
      getListFlag: false,
      listData: [],
      page: 1
    };
  },
  created() {
    this.getUserCoupon();
  },
  mounted() {},
  computed: {},
  methods: {
    toDetail(id) {
      if (this.status) {
        return;
      }
      this.$router.push({
        path: "/couponDetail",
        name: "couponDetail",
        query: { id: id }
      });
    },
    getCouponList(data) {
      console.log("getCouponList", data);
      // 获取优惠券列表
    },
    changeTab() {
      // changeTab
      if (this.curIndex == 0 && this.tabIndex == 0) {
        this.couponTypeFlag = !this.couponTypeFlag;
      } else {
        this.couponTypeFlag = false;
      }
      if (this.curIndex == this.tabIndex) {
        return false;
      }
      this.curIndex = this.tabIndex;
      this.status = this.curIndex;
      if (this.curIndex > 0) {
        this.couponType = 0;
      }
      this.getUserCoupon();
    },
    clickCouponType(type) {
      console.log("couponType", type);
      this.couponType = type;
      this.couponTypeFlag = false;
      this.getUserCoupon();
    },
    clickButton() {
      // 点击按钮
      if (this.status == 0) {
        this._linkFun("/life");
      }
    },
    pullingDown() {
      // 下拉刷新
      this.page = 1;
      this.getUserCoupon();
    },
    pullingUp() {
      // 上拉加载
      let vm = this;
      if (vm.pullUpLoadFlag) {
        vm.$refs.scroll.forceUpdate(false);
        return;
      }
      vm.page += 1;
      vm.getUserCoupon(1);
    },
    getUserCoupon(flag) {
      let vm = this;
      let loading = true;
      vm.getListFlag = false;
      if (flag) {
        loading = false;
        vm.getListFlag = true;
      }
      let params = {};
      params.status = vm.status;
      params.coupon_user_type = vm.couponType;
      params.page = vm.page;
      vm.$post("/app/user/userCoupon", params, { loading: loading }).then(
        res => {
          console.log("userCoupon", res);
          vm.getListFlag = true;
          if (vm.page == 1) {
            vm.listData = res.data;
          } else {
            vm.listData = vm.listData.concat(res.data);
          }
          if (res.data.length < 10) {
            vm.pullUpLoadFlag = true;
          } else {
            vm.pullUpLoadFlag = false;
          }
        }
      );
    }
  },
  watch: {}
  // beforeDestroy: {}
};
</script>

<style lang="less" scoped>
.scroll-wrapper {
  top: 88px;
  background: #f4f4f4;
}
.coupon {
  padding: 1.1px 0;
}
/deep/.van-tabs {
  top: 44px;
  position: relative;
  .van-tab {
    &:first-child {
      .van-tab__text {
        position: relative;
        padding-right: 12px;
      }
      .default {
        &::after {
          content: "";
          position: absolute;
          top: 50%;
          margin-top: -2px;
          right: 0;
          width: 0;
          height: 0;
          border: 5px solid transparent;
          border-top-color: #646566;
          transition: transform 0.5s;
        }
        &.active {
          &::after {
            margin-top: -7px;
            transform: rotate(180deg);
          }
        }
      }
    }
  }
  // .van-tab--active
  .van-tabs__line {
    background-color: #fd4553;
  }
  .van-tabs__content {
    .van-tab__pane {
      position: relative;
      height: calc(100vh - 88px);
    }
  }
}
.couponType-overlay {
  z-index: 91 !important;
  top: 88px;
  background-color: rgba(0, 0, 0, 0);
}
.pull-down {
  z-index: 92;
  position: absolute;
  top: 54px;
  left: 10px;
  width: calc(33.33% - 20px);
  background: #fff;
  border-radius: 4px;
  box-shadow: 0px 0px 5px 0px rgba(166, 166, 166, 0.5);
  &::before {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -6px;
    width: 0;
    height: 0;
    border: 6px solid transparent;
    border-bottom-color: #fff;
  }
  p {
    text-align: center;
    line-height: 30px;
    border-top: 1.1px solid #f4f4f4;
    &:first-child {
      border: 0;
    }
    &.active {
      color: #fd4553;
    }
  }
}

.item {
  position: relative;
  margin: 10px 10px 0 10px;
  padding: 0 15px;
  line-height: 1;
  background: #fff;
  border-radius: 8px;
  // border: 1px solid #58c4e6;
  box-shadow: 0px 2px 2px 0px rgba(221, 221, 221, 0.5);
  &.disabled {
    color: #999;
    .text-red,
    .text-orange {
      color: #999;
    }
    .info {
      .center {
        .ticket,
        .ticket.style2 {
          color: #999;
          border-color: #999;
        }
      }
    }
    .use-info {
      /deep/.van-button--mini {
        background: #999;
      }
    }
  }
  .info {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 10px 0;
    border-bottom: 1.1px dashed #ececec;
    .left {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 10px;
      width: 60px;
      height: 60px;
      border-radius: 4px;
      overflow: hidden;
      img {
        max-width: 100%;
        max-height: 100%;
      }
    }
    .center {
      flex: 1;
      text-align: left;
      h3 {
        font-size: 14px;
        line-height: 1;
        font-weight: 400;
      }
      .ticket {
        margin: 5px 0;
        display: inline-block;
        padding: 2px 5px;
        line-height: 1.2;
        color: #fc3c46;
        border: 1.1px solid #fc3c46;
        border-radius: 3px;
        &.style2 {
          color: #fe7800;
          border: 1.1px solid #fe7800;
        }
      }
    }
    .right {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      margin-left: 10px;
      min-width: 70px;
      h4 {
        margin-bottom: 5px;
        font-size: 16px;
      }
    }
  }
  .use-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 36px;
    overflow: hidden;
    p {
      margin-right: 10px;
      flex: 1;
    }
    /deep/.van-button--mini {
      padding: 0 10px;
      min-width: 70px;
    }
  }
  .cro-wrap {
    z-index: 1;
    position: absolute;
    bottom: 30px;
    width: 6px;
    height: 12px;
    &.left {
      left: 0;
      .top {
        // border-bottom-color: #58c4e6;
        // border-right-color: #58c4e6;
        border-radius: 0px 0px 6px 0px;
      }
      .bottom {
        // border-top-color: #58c4e6;
        // border-right-color: #58c4e6;
        border-radius: 0px 6px 0px 0px;
      }
    }
    &.right {
      right: 0;
      .top {
        // border-bottom-color: #58c4e6;
        // border-left-color: #58c4e6;
        border-radius: 0px 0px 0px 6px;
      }
      .bottom {
        // border-top-color: #58c4e6;
        // border-left-color: #58c4e6;
        border-radius: 6px 0px 0px 0px;
      }
    }
    .cro {
      position: absolute;
      width: 6px;
      height: 6px;
      background: #f4f4f4;
      // border: 1px solid #f4f4f4;
      &.top {
        bottom: 0;
      }
      &.bottom {
        top: 0;
      }
    }
  }
}
</style>
